export type WorkflowFiltersMessages = {
  //Error message
  errorRequiredTrigger: string;
  errorRequiredDescription: string;
  errorRequiredWorkflowId: string;
  errorType: string;
  workflowSaveError: string;

  //Sucess message
  workflowSavedSuccess: string;

  //Label message
  triggerLabel: string;
  descriptionLabel: string;
  workflowIdLabel: string;
  filterByLabel: string;
  valueLabel: string;
  search: string;

  //Field Labels
  nameLabel: string;
  agentTypeLabel: string;
  statusLabel: string;

  //Options
  orderStatus: string;
  startFlow: string;
  shopping: string;
  statusTrueOption: string;
  statusFalseOption: string;
  titleOption: string;
  descriptionOption: string;
  workflowTypeOption: string;
  statusOption: string;
  allOption: string;
  activeOption: string;
  inactiveOption: string;
  noWorkflowOption: string;
  noTriggergOption: string;

  //Button message
  activateWorkflowButton: string;
  filterButton: string;
  moreFiltersButton: string;
  lessFiltersButton: string;
  clearFiltersButton: string;
};

export const WORKFLOW_FILTERS_MESSAGES: WorkflowFiltersMessages = {
  //Error message
  errorRequiredTrigger: "O Tipo do agente é obrigatório",
  errorRequiredDescription: "A descrição do agente é obrigatória",
  errorRequiredWorkflowId: "O agente é obrigatório",
  errorType: "Gatilho não encontrado",
  workflowSaveError: "Erro ao salvar o agente.",

  //Sucess message
  workflowSavedSuccess: "Agente salvo com sucesso.",

  //Label message
  triggerLabel: "Tipo do agente",
  descriptionLabel: "Descrição do agente",
  workflowIdLabel: "Agente",
  filterByLabel: "Filtrar por",
  filterButton: "Filtrar",
  valueLabel: "Valor",
  search: "Valor",

  //Field Labels
  nameLabel: "Nome",
  agentTypeLabel: "Tipo do Agente",
  statusLabel: "Status",

  //Options
  orderStatus: "Status do pedido",
  startFlow: "Iniciar fluxo",
  shopping: "Shopping",
  noWorkflowOption: "Nenhum Agente selecionado",
  noTriggergOption: "Nenhum gatilho selecionado",
  statusTrueOption: "Ativo",
  statusFalseOption: "Desativado",
  statusOption: "Status",
  titleOption: "Nome",
  descriptionOption: "Descrição",
  workflowTypeOption: "Tipo do agente",
  allOption: "Todos",
  activeOption: "Ativo",
  inactiveOption: "Inativo",

  //Button message
  activateWorkflowButton: "Salvar",
  moreFiltersButton: "Mais Filtros",
  lessFiltersButton: "Menos Filtros",
  clearFiltersButton: "Limpar Filtros",
};
